import type { ReadableAtom } from 'nanostores'

import { useStore } from '@nanostores/react'
import clsx from 'clsx'
import {
	type CSSProperties,
	memo,
	type PropsWithChildren,
	useLayoutEffect
} from 'react'

import css from './ContactsTable.module.css'
import {
	$isRecalculated,
	SizeKeyContext,
	type SizeMode,
	sizeUtils
} from './ResizeButton'

type Props = PropsWithChildren<{ store: ReadableAtom<string> }>

function Wrapper_({
	children,
	sizeKey = 'Contact',
	store
}: Props & {
	sizeKey?: SizeMode
}) {
	const { $style } = sizeUtils[sizeKey]

	const colTemplate = useStore(store),
		isRecalculated = useStore($isRecalculated),
		sizeStyles = useStore($style)

	useLayoutEffect(() => {
		const { $sizes, key } = sizeUtils[sizeKey]
		return $sizes.listen(sizes =>
			localStorage.setItem(key, JSON.stringify(sizes))
		)
	}, [sizeKey])

	return (
		<div
			className={clsx(
				'app-scroll',
				css.scroll,
				isRecalculated && css.isRowChanging
			)}
			style={{ ...sizeStyles, '--cols-map': colTemplate } as CSSProperties}
		>
			<table className={css.table}>
				<SizeKeyContext.Provider value={sizeKey}>
					{children}
				</SizeKeyContext.Provider>
			</table>
		</div>
	)
}

export const Wrapper = memo(Wrapper_)
